import React, { useState } from 'react'
import Box from '@material-ui/core/Box'
import { Image } from 'cloudinary-react'
import { CLOUDINARY_NAME } from '../../constants'
import PlayCircleOutlineIcon from '@material-ui/icons/PlayCircleOutline'
import makeStyles from '@material-ui/core/styles/makeStyles'

const useStyles = makeStyles((theme) => ({
    iFrame: {
        maxWidth: '100%',
        maxheight: '100%',
    },
    thumbnailContainer: {
        position: 'relative',
        cursor: 'pointer',
    },
    thumbnail: {
        opacity: 1,
        transition: 'opacity 300ms',
    },
    playIcon: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        color: 'white',
        fontSize: '3rem',
        [theme.breakpoints.up('sm')]: {
            fontSize: '4rem',
        },
    },
}))

const LazyLoadedVideo = ({
    videoId,
    height,
    width,
    thumbnail,
    thumbnailAlt,
}) => {
    const classes = useStyles()

    const [loadIframeVideo, setLoadIframeVideo] = useState(false)

    const handleIframeVideoClick = () => {
        setLoadIframeVideo(true)
    }

    return (
        <>
            {!loadIframeVideo && (
                <Box
                    className={classes.thumbnailContainer}
                    onClick={handleIframeVideoClick}
                >
                    <Image
                        cloudName={CLOUDINARY_NAME}
                        publicId={thumbnail}
                        className={`${classes.thumbnail}`}
                        alt={thumbnailAlt}
                        width={width ? width : '100%'}
                        height={height ? height : '100%'}
                        loading="lazy"
                    />
                    <PlayCircleOutlineIcon className={classes.playIcon} />
                </Box>
            )}
            {loadIframeVideo && (
                <>
                    <iframe
                        width={width ? width : '100%'}
                        height={height ? height : '100%'}
                        src={`https://www.youtube.com/embed/${videoId}?rel=0&amp;enablejsapi=1&autoplay=1`}
                        title="YouTube video player"
                        frameBorder="0"
                        className={classes.iFrame}
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                    />
                </>
            )}
        </>
    )
}

export default LazyLoadedVideo
